import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./core/login/login.component').then(m => m.LoginComponent) },
  { path: 'password/edit', loadComponent: () => import('./core/password/password.component').then(m => m.PasswordComponent) },
  { path: 'help_desk', loadComponent: () => import('./users/helpdesk/helpdesk.component').then(m => m.HelpdeskComponent) },
  {
    path: "**",
    redirectTo: "/home/dashboard"
  },
];
